<div class="sign-in">
  <p class="title">Sign In</p>
  <form [formGroup]="signInForm" (ngSubmit)="onSubmit()">
    <mat-form-field class="form-input">
      <mat-label>Email</mat-label>
      <input 
        matInput 
        id="email"
        placeholder="Enter Email"
        type="email"
        formControlName="email"
        required
      >
      @if (signInForm.get('email')?.invalid && signInForm.get('email')?.touched) {
        <mat-error>Please enter a valid email</mat-error>
      }
    </mat-form-field>

    <mat-form-field class="form-input">
      <mat-label>Password</mat-label>
      <input 
        matInput 
        id="password"
        [type]="hidePassword() ? 'password' : 'text'"
        placeholder="Enter Password"
        formControlName="password"
        required
      >
      <button
        mat-icon-button
        matSuffix
        type="button"
        (click)="clickPasswordEvent($event)"
        [attr.aria-label]="hidePassword() ? 'Show password' : 'Hide password'"
        [attr.aria-pressed]="hidePassword()"
      >
        <mat-icon>{{hidePassword() ? 'visibility_off' : 'visibility'}}</mat-icon>
      </button>
      
      @if (signInForm.get('password')?.invalid && signInForm.get('password')?.touched) {
        <mat-error>Invalid password</mat-error>
      }
    </mat-form-field>

    <div class="forgot-link">
      <p class="link">
        Forgot password?
      </p>
    </div>

    <button 
      mat-flat-button 
      type="submit" 
      class="form-btn"
    >
      Sign In
    </button>

    <p class="link account-link" (click)="onCreateAccountLink()">
      Create an account
    </p>
  </form>
</div>